import React, { Fragment, useMemo } from "react";
import { prosthesisTypes } from "../../Formula/prosthesis";
import { ClickAwayListener } from "@mui/material";
import OptionSelect from "../../OptionSelect";
import "./index.scss";
import { surgicalPart2DFilter } from "../../formulaHelpers";

const Basic2D = ({
  formulaInformation,
  type,
  onToothClick,
  onGapsClick,
  targetWidth = null,
  targetHeight = null,
  targetTopMargin = null,
  targetLeftMargin = null,
  toggleOptionSelect = () => {},
  setOptionSelect = () => {},
  stateSelectionType = null,
  sectionName = null
}) => {
  const {
    tooth,
    prosthesis,
    gaps
  } = useMemo(() => {
    if (type === "surgical") {
      return surgicalPart2DFilter(formulaInformation);
    }

    return {
      tooth: formulaInformation.tooth || [],
      prosthesis: formulaInformation.prosthesis || [],
      gaps: formulaInformation.gaps || []
    };
  }, [formulaInformation, type]);
  const width = 713;
  const height = 1116;
  let scale = useMemo(() => {
    let basicScale = 0.5;
    let widthScale = 1;
    let heightScale = 1;

    if (targetWidth) {
      widthScale = (targetWidth / width).toFixed(5);
    }

    if (targetHeight) {
      heightScale = (targetHeight / height).toFixed(5);
    }

    if (widthScale === 1 && heightScale === 1) {
      return basicScale;
    }

    return Math.min(heightScale, widthScale);
  }, [targetHeight, targetWidth]); // Sort tooth for render zIndex order

  let sortedTooth = [...tooth];
  sortedTooth.sort((a, b) => b.sortRender - a.sortRender);

  function upscale(val) {
    return Math.round(val * scale);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "visualFormContainer",
    style: {
      width: upscale(width),
      height: upscale(height),
      marginTop: targetTopMargin || "inherit"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: require("./assets/gumTop.png"),
    style: {
      position: "absolute",
      width: upscale(485),
      height: upscale(485),
      top: upscale(76),
      left: upscale(109)
    },
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: require("./assets/gumBottom.png"),
    style: {
      position: "absolute",
      width: upscale(546),
      height: upscale(411),
      top: upscale(590),
      left: upscale(82)
    },
    alt: ""
  }), prosthesis.map(prosthesis => /*#__PURE__*/React.createElement("img", {
    src: require(`./assets/prosthesis/${prosthesis}.png`),
    style: {
      position: "absolute",
      left: upscale(prosthesisTypes[prosthesis].x),
      top: upscale(prosthesisTypes[prosthesis].y),
      width: upscale(prosthesisTypes[prosthesis].width),
      height: upscale(prosthesisTypes[prosthesis].height),
      zIndex: prosthesisTypes[prosthesis].zIndex
    },
    alt: "",
    key: prosthesis
  })), sortedTooth.map(item => /*#__PURE__*/React.createElement(Fragment, {
    key: item.name
  }, item?.optionSelect && /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: () => toggleOptionSelect(item.name, false)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OptionSelect, {
    name: item.name,
    select: setOptionSelect,
    top: upscale(item.actionBtn.position.y) + upscale(item.actionBtn.position.width),
    left: upscale(item.actionBtn.position.x) + upscale(item.actionBtn.position.height),
    isEight: item.isEighth,
    isReverse: item.position === "bottom",
    stateSelectionType: stateSelectionType
  }))), item.actionBtn.isActive && /*#__PURE__*/React.createElement("div", {
    key: item.name,
    style: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      top: upscale(item.actionBtn.position.y),
      left: upscale(item.actionBtn.position.x),
      width: upscale(item.actionBtn.position.width),
      height: upscale(item.actionBtn.position.height),
      border: "2px solid #1e88e5",
      borderRadius: "50%",
      fontSize: "14px",
      cursor: "pointer",
      zIndex: 7,
      backgroundColor: item.name === sectionName ? "#65b5f5" : "transparent",
      color: item.name === sectionName ? "#fff" : "var(--dark-text)"
    },
    onClick: () => onToothClick(item)
  }, item.name), item.toothElementsActive.map(el => /*#__PURE__*/React.createElement("img", {
    key: `${el}${item.name}`,
    src: require(`./assets/${el}/${item.name}.png`),
    style: {
      position: "absolute",
      top: upscale(item.toothElements[el].y),
      left: upscale(item.toothElements[el].x),
      width: upscale(item.toothElements[el].width),
      height: upscale(item.toothElements[el].height),
      zIndex: item.toothElements[el].zIndex,
      opacity: 1
    },
    onClick: () => {
      if (item.actionBtn.isActive) {
        return onToothClick(item);
      }

      return null;
    },
    alt: ""
  })))), gaps.map(gap => /*#__PURE__*/React.createElement(Fragment, {
    key: gap.name
  }, gap.actionBtn.isActive && /*#__PURE__*/React.createElement("img", {
    src: require(`./assets/gapsActionBtn/${gap.name}.png`),
    style: {
      position: "absolute",
      top: upscale(gap.actionBtn.position.y),
      left: upscale(gap.actionBtn.position.x),
      width: upscale(gap.actionBtn.position.width),
      height: upscale(gap.actionBtn.position.height),
      cursor: "pointer",
      zIndex: 4
    },
    onClick: () => onGapsClick(gap),
    alt: ""
  }), gap.connection.isActive && /*#__PURE__*/React.createElement("img", {
    src: require(`./assets/connections/${gap.name}.png`),
    style: {
      position: "absolute",
      top: upscale(gap.connection.position.y),
      left: upscale(gap.connection.position.x),
      width: upscale(gap.connection.position.width),
      height: upscale(gap.connection.position.height),
      zIndex: gap.connection.position.zIndex
    },
    alt: ""
  }))));
};

export default Basic2D;